/**
 * T-045: the coverage lines a certificate must show, one text box each. Used for the default
 * limits and for each region override (where an empty box falls back to the default).
 */
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import type { CoverageKey, CoverageText } from '@/lib/portalCoiSettingsApi';

interface Props {
  id: string;
  fields: { key: CoverageKey; label: string }[];
  value: CoverageText;
  onChange: (next: CoverageText) => void;
  /** Shown in an empty box, e.g. the default it falls back to. */
  placeholders?: Partial<CoverageText>;
}

export function CoverageFields({ id, fields, value, onChange, placeholders }: Props) {
  return (
    <div className="grid gap-3 md:grid-cols-2">
      {fields.map((f) => (
        <div key={f.key} className="flex flex-col gap-1.5">
          <Label htmlFor={`${id}-${f.key}`}>{f.label}</Label>
          <Textarea
            id={`${id}-${f.key}`}
            rows={3}
            maxLength={1000}
            value={value[f.key]}
            placeholder={placeholders?.[f.key] || ''}
            onChange={(e) => onChange({ ...value, [f.key]: e.target.value })}
          />
        </div>
      ))}
    </div>
  );
}
